import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { target: String }

  open(event) {
    event.preventDefault()
    const modal = document.getElementById(this.targetValue)
    if (!modal) return

    const controller = this.application.getControllerForElementAndIdentifier(modal, "modal")
    if (controller) {
      controller.open(event)
    }
  }
}
